<template>
  <m-geo-box>
    <b-checkbox class="content" v-model="isTotalUsa">Total USA</b-checkbox>
  </m-geo-box>
</template>

<script>
import MGeoBox from "@/components/geo/MGeoBox";
export default {
  components: {
    MGeoBox,
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
    };
  },
  computed: {
    isTotalUsa: {
      get() {
        return (
          this.$store.state.order.GeoType === 20 &&
          this.$store.getters["order/geos"].length > 0
        );
      },
      set(val) {
        if (val) {
          this.$store.commit("order/addGeo", {
            GeoKeyCode: "1",
            GeoKeyDesc: "NATIONWIDE",
            GeoType: 20,
          });
        } else {
          this.$store.commit("order/cleanGeo");
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  text-align: center;
}
.custom-control-input:disabled ~ .custom-control-label {
  color: $color-primary !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/GeoTotalUsa.vue